import React, { ForwardedRef } from 'react';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';
import Image from 'components/common/Image';

import styles from './RectangleTile.module.scss';

interface RectangleTileProps {
  logoSrc?: string | null;
  title?: string | null;
  focusId?: string | number | null;
  className?: string | null;
  onFocusSet?: () => void;
  domRef?: ForwardedRef<HTMLSpanElement> | null;
  onClick?: () => void;
  item?: unknown | null;
  row?: unknown | null;
}

const RectangleTile = ({
  logoSrc = null,
  title = null,
  focusId = null,
  className = null,
  onFocusSet = () => {},
  domRef = null,
  onClick = () => {},
}: RectangleTileProps) => {
  return (
    <span className="flex-shrink-0" ref={domRef} key={focusId}>
      <Selectable
        onSelect={onClick}
        focusId={focusId}
        className={className}
        onFocusSet={onFocusSet}
        data-testid="media-tile"
        ttsText={title}
        render={({ hasFocus }) => (
          <div
            className={classNames(
              'd-flex',
              'flex-column',
              styles.tile,
              hasFocus ? styles.focused : styles.unfocused,
            )}
          >
            <button
              type="button"
              onClick={onClick}
              className={classNames('w-100 h-100', styles.button)}
            >
              <div
                className={classNames(
                  'w-100 h-100',
                  'd-flex flex-row align-items-center',
                )}
              >
                <Image
                  alt="logo"
                  src={logoSrc}
                  className={classNames(styles.rectangleLogo)}
                />

                <span className={styles.title}> {title}</span>
              </div>
            </button>
          </div>
        )}
      />
    </span>
  );
};

// Export inner component for testing default parameters
export { RectangleTile as RectangleTileInner };

export default React.memo(
  React.forwardRef<HTMLSpanElement, Omit<RectangleTileProps, 'domRef'>>((props, ref) => <RectangleTile {...props} domRef={ref} />),
);
